var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"d-flex justify-content-center mb-1",staticStyle:{"height":"200px","align-items":"center"}},[_c('b-spinner',{attrs:{"label":"Loading..."}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }